import { CategoryGroup } from "../CategoryGroup.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const CategoryGroupNameMap: Record<CategoryGroup, LocalizedString> = {
	[CategoryGroup.Products]: {
		[Locale.cs]: "/produkty",
		[Locale.en]: "/products",
		[Locale.sk]: "/produkty",
	},
	[CategoryGroup.ProductionAndServices]: {
		[Locale.cs]: "/vyroba-a-sluzby",
		[Locale.en]: "/production-and-services",
		[Locale.sk]: "/vyroba-a-sluzby",
	},
};

export function getCategoryGroupsPath(tenant: Tenant, group: CategoryGroup): string {
	return getPathInLocale(tenant.locale, CategoryGroupNameMap[group]);
}
